import * as React from 'react';
import cx from 'classnames';
import {
  CheckmarkCircleLine,
  FailLine,
  InfoLine,
  WarningLine,
} from '@dropbox/dig-icons/assets';
import { UIIcon } from '@dropbox/dig-icons';
import styles from './tone.module.css';

// todo: remove this file as soon as we upgrade DIG to a version that includes the Tone component for Snackbar
export interface ToneProps {
  tone: 'success' | 'alert' | 'info' | 'warning';
}

const getIconFromTone = (tone: ToneProps['tone']) => {
  switch (tone) {
    case 'success':
      return CheckmarkCircleLine;
    case 'alert':
      return FailLine;
    case 'info':
      return InfoLine;
    case 'warning':
      return WarningLine;
    default:
      throw new Error(`Unsupported tone: ${tone}`);
  }
};

export const Tone = ({ tone }: ToneProps) => {
  return (
    <div className={cx(styles.tone, styles[tone])}>
      <UIIcon src={getIconFromTone(tone)} size="medium" role="presentation" />
    </div>
  );
};
